import { __decorate } from "tslib";
import { ActivityEventType } from '@metaos/mfs-telemetry';
import { mfsErrorHandler } from '../errors/mfsErrorHandler';
import { toCard } from '../utility/cardUtils';
import { taggedRelationshipIn } from '../utility/constant/internalRelationships';
import { getMfsTag, toTag } from '../utility/taggingUtils';
import { logActivity } from '../utility/telemetry';
import { AscendingCompareFunc, getDefaultCompareFunc, orderByIdentifier } from '../utility/viewUtils';
/** Concrete implementation for Full View retriever. */
export class TagView {
    constructor(dataStore) {
        this.dataStore = dataStore;
    }
    /**
     * Gets list of cards that have been tagged by a given set of tag ids.
     * The result is ordered by updatedAt and will search for cards that contain any of the listed tags, but does not require that they contain all tags. TagIds provided that are not found will be skipped.
     *
     * Tag view is a projection of cards based on the cards name, and returns a flat list of `CardRecord` containing
     * the `Card`.
     *
     * Tag view accepts a `criteria.filter` which will filter out based on the tags attached to each card. The filter provided should not expect to have access to the card properties and should only expect to recieve a tag.
     *
     * @param criteria The user specified criteria used for searching and querying
     * @returns An IterableIterator of `Card`
     * @throws When the tagIds within the criteria are invalid or when an unexpected error happens while querying.
     */
    retrieve(criteria) {
        if (criteria.tagIds.length === 0)
            return [].values();
        try {
            const results = [];
            const uniqueCardItemIds = new Set();
            new Set(criteria.tagIds).forEach((tagId) => {
                var _a;
                const mfsTag = getMfsTag(this.dataStore, tagId);
                if (!mfsTag)
                    return;
                if (criteria.query && criteria.query.filter && !((_a = criteria.query) === null || _a === void 0 ? void 0 : _a.filter(toTag(mfsTag)))) {
                    return;
                }
                for (const relatedItem of this.dataStore.getRelatedItems(mfsTag.id, taggedRelationshipIn)) {
                    const card = toCard(this.dataStore, relatedItem, true);
                    if (!uniqueCardItemIds.has(card.uniqueId)) {
                        uniqueCardItemIds.add(card.uniqueId);
                        // add the item to the return list
                        results.push(card);
                    }
                }
            });
            const cards = orderByIdentifier(results, (arg) => { var _a; return ((_a = arg.updatedAt) !== null && _a !== void 0 ? _a : 0); }, getDefaultCompareFunc(criteria.order));
            return sortTags(cards);
        }
        catch (error) {
            throw mfsErrorHandler(`An unexpected error has happened, please try again.`, error);
        }
    }
}
__decorate([
    logActivity(ActivityEventType.SINGLE, undefined, 'viewByTag')
], TagView.prototype, "retrieve", null);
function* sortTags(cards) {
    for (const card of cards) {
        card.tags = orderByIdentifier(card.tags, (tag) => tag.value.toLowerCase(), AscendingCompareFunc);
        yield card;
    }
}
//# sourceMappingURL=tagView.js.map